import gsap from 'gsap';

export default class Form {
  constructor() {
    this.section = document.querySelector('.s-form');
    this.send = document.querySelector('.s-form-send');
    this.rows = document.querySelectorAll('.s-form-row');
    this.labels = document.querySelectorAll('.s-form-label');
    this.fields = document.querySelectorAll('.s-form-field');
    this.checkbox = document.querySelector('.s-form-checkbox');
    this.dropdown = document.querySelectorAll('.s-form-dropdown');
    this.options = document.querySelectorAll('.s-form-dropdown li');
  }

  validate = () => {
    if (this.rows.length === this.section.querySelectorAll('.is-valid').length) {
      this.send.style.pointerEvents = 'all';
      gsap.to(this.send, {
        duration: 0.5,
        color: '#ffffff',
      });
    } else {
      this.send.style.pointerEvents = '';
      gsap.to(this.send, {
        duration: 0.5,
        color: '#3D4A5A',
      });
    }
  }

  validateChekcbox() {
    const value = this.checkbox.checked;
    this.box = document.querySelector('.s-form-checkmark');
    if (value) {
      gsap.to(this.box, {
        duration: 0.5,
        borderColor: '#DBE2D6',
      });
    } else {
      gsap.to(this.box, {
        duration: 0.5,
        borderColor: '#e73a1a',
      });
    }
  }

  mouseEnter = (i) => {
    const notification = this.rows[i].querySelector('.s-form-notification');

    if (notification) {
      notification.remove();
    }
  }

  mouseLeave = () => {
  }

  send = () => { }

  errors = (e) => {
    const el = e.target;

    const row = el.closest('.s-form-row');
    const field = el.closest('.s-form-row').querySelector('.s-form-field');
    const label = el.closest('.s-form-row').querySelector('.s-form-label');

    let notification = el.closest('.s-form-row').querySelector('.s-form-notification');

    if (notification) {
      notification.remove();
    } else {
      notification = document.createElement('div');
    }

    if (field.value) {
      notification.innerHTML = 'Compile valid email address, please.';
    } else {
      notification.innerHTML = 'Please add missing information.';
    }

    if (field.classList.contains('field-file') && field.files.lenght === 0) {
      notification.innerHTML = 'Please add file.';
    }

    field.value = '';

    notification.classList.add('s-form-notification');

    el.closest('.s-form-col').appendChild(notification);

    gsap.to(row, {
      duration: 0.5,
      color: '#E73A1A',
    });
    gsap.to(label, {
      duration: 0.5,
      borderColor: '#E73A1A',
    });
    gsap.to(el, {
      duration: 0.5,
      borderColor: '#E73A1A',
    });
  }

  setDropdown = (el) => {
    const selection = el;
    const list = selection.closest('.s-form-col').querySelector('ul');
    if (list.style.display === 'block') {
      list.style.display = 'none';
    } else {
      list.style.display = 'block';
    }
  }

  setOption = (el) => {
    const selection = el;
    const value = selection.innerHTML;

    const field = selection.closest('.s-form-col').querySelector('.s-form-field');
    field.innerHTML = value;

    const hidden = selection.closest('.s-form-col').querySelector('.s-form-hidden');
    hidden.value = value;

    const label = selection.closest('.s-form-row').querySelector('.s-form-label');
    gsap.to(label, { color: '#DBE2D6', duration: 0.5 });
  }

  addEvents = () => {
    this.send.addEventListener('click', this.send);

    document.addEventListener('invalid', (e) => {
      this.errors(e);
      e.preventDefault();
    }, true);

    this.checkbox.addEventListener('invalid', () => this.validateChekcbox(), true);
    [...this.rows].forEach((row, i) => {
      row.addEventListener('keyup', () => this.validate(i));
    });

    [...this.rows].forEach((row, i) => {
      row.addEventListener('mouseenter', () => this.mouseEnter(i));
    });

    [...this.rows].forEach((row, i) => {
      row.addEventListener('mouseleave', () => {
        this.mouseLeave(i);
      });
    });

    [...this.dropdown].forEach((el) => {
      el.addEventListener('click', () => {
        this.setDropdown(el);
      });
    });

    [...this.options].forEach((el) => {
      el.addEventListener('click', () => {
        this.setOption(el);
      });
    });
  }

  removeEvents = () => { }

  destroy = () => {
    this.removeEvents();
  }

  init = () => {
    this.addEvents();
  }
}
